export enum ETypeFolder {
  PUBLIC = 1,
  PRIVATE = 2,
  CLIENT = 3,
  RENEWAL = 4,
  EDGE = 5,
  CONTRIBUTION = 6,
  PUBLIC_RENEWAL = 7,
  QUOTE_BOOK_FOLDER = 8,
}

export const documentStatus = {
  approved: 'Approved',
  declined: 'Declined',
  waitingForApproval: 'Waiting For Approval',
};

export const folderTypeCategories = {
  [ETypeFolder.PUBLIC]: 'public',
  [ETypeFolder.EDGE]: 'public',
  [ETypeFolder.PRIVATE]: 'private',
  [ETypeFolder.CLIENT]: 'private',
  [ETypeFolder.RENEWAL]: 'private',
  [ETypeFolder.CONTRIBUTION]: 'public',
  [ETypeFolder.PUBLIC_RENEWAL]: 'public',
  [ETypeFolder.QUOTE_BOOK_FOLDER]: 'private',
};

export const isEdgePublicDocumentPath = (path?: string | null): boolean => {
  if (!path) {
    return false;
  }

  return path.includes('edge-safe-public') || path.includes('edge-public');
};
